import styled from "styled-components";
import { COLORS } from "../../../../styles/constants.style";

export const EditViewParticipantWrapper = styled.div`
  .view-generic-account-tab {
    display: flex;
    margin: 16px 0;
    justify-content: end;
  }
  .participant-details-container {
    margin: 16px 0;
  }

  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .participant-section-grid {
    padding: 24px 16px;
    align-items: center;
  }
  .separator-space-vertical {
    width: 2px;
    height: 32px;
    margin: 10px;
    background-color: ${COLORS.cirrus_black4};
  }
`;
